import React from "react";

import classes from "./Header.module.css";

export default function Header() {
  return (
    <header className={`${classes.center} ${classes.headerText}`}>
      <h1>פרחי נסטל – סיטונאות פרחים וזרי פרחים טריים במרכז הארץ</h1>
    </header>
  );
}
